import { OfficeTypeEnum } from "@/types/types";
import styles from "../page-searchbar.module.css";
import { IoIosArrowDown } from "react-icons/io";

export default function OfficeTypeSelectorServer({
  t,
  activeOfficeType,
}: {
  t: any;
  activeOfficeType: OfficeTypeEnum | null;
}) {
  return (
    <div className={`${styles.selectWrapper} ${styles.typeItemWrapper}`}>
      <button className={styles.pill}>
        <div className={styles.textWrapper}>
          <span>
            {activeOfficeType !== null && activeOfficeType !== undefined
              ? t(activeOfficeType)
              : t("officeTypeTitle")}
          </span>
        </div>
        <span className={styles.chevron}>
          <IoIosArrowDown />
        </span>
      </button>
    </div>
  );
}
